import React from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';

export const SwaggerArticle = ({ url }: {
    url: string;
}) => {
    return (
        <div style={{ padding: '1rem' }}>
            <SwaggerUI url={url} />
        </div>
    );
};
